<style>
  .ivu-modal-footer{border: none;}
  .ivu-select-multiple{height: 32px;}
  .ivu-select-selection{z-index:100;}
</style>
<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query2">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="学校名称" prop="schoolName">
                <Input
                  v-model="query2.schoolName"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="学校类型" prop="schoolType">
                <Select v-model="query2.schoolType" clearable>
                  <Option
                    v-for="item in schoolTypelist"
                    :key="item.index"
                    :value="item.type"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="行政区域" prop="schoolRegion">
                <Select v-model="query2.schoolRegion" clearable>
                  <Option
                    v-for="item in schoolRegionlist"
                    :key="item.index"
                    :value="item.type"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="学校机构" prop="schoolIspublic">
                <Select v-model="query2.schoolIspublic" clearable>
                  <Option
                    v-for="item in schoolIspubliclist"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
           </row>
        </i-form>

      </div>
      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader2"
            :border="true"
            :loading="isLoading"
            :data="tableData2"
            stripe
            ref="table"
          >
            <template slot-scope="{ row, index }" slot="action2">
              <!-- <span class="action">[删除]</span> -->
              <span class="action"  @click="handleschoolDetail(row)">[修改]</span>
            </template>

          </i-table>
        </div>
        <div class="page">
          <page
            :total="total2"
            :current="pageNum2"
            @on-change="pageChange2"
            show-total
          />
        </div>
      </div>

      <Modal  v-model="modal1" title="设置学校信息">
          <i-form ref="search" :model="query3">
            <row :gutter="80">
              <i-col span="12">
                <form-item label="行政区域" prop="schoolRegion">
                  <Select v-model="query3.schoolRegion" clearable>
                    <Option
                      v-for="item in schoolRegionlist"
                      :key="item.index"
                      :value="item.type"
                      :label="item.type"
                    ></Option>
                  </Select>
                </form-item>
              </i-col>
              <i-col span="12">
                <form-item label="关联部门" prop="deptId">
                  <Select v-model="query3.deptId" clearable>
                    <Option
                      v-for="item in deptNamelist"
                      :key="item.index"
                      :value="item.id"
                      :label="item.dept_name"
                    ></Option>
                  </Select>
                </form-item>
              </i-col>

              <i-col span="12">
                <form-item label="学校机构" prop="schoolIspublic">
                  <Select v-model="query3.schoolIspublic" clearable>
                    <Option
                      v-for="item in schoolIspubliclist"
                      :key="item.index"
                      :value="item.type"
                      :label="item.type"
                    ></Option>
                  </Select>
                </form-item>
              </i-col>
              <i-col span="12">
                <form-item label="学校类型" prop="schoolType">
                  <Select v-model="query3.schoolType" clearable>
                    <Option
                      v-for="item in schoolTypelist"
                      :key="item.index"
                      :value="item.type"
                      :label="item.type"
                    ></Option>
                  </Select>
                </form-item>
              </i-col>
              <i-col span="12">
                <form-item label="学校名称" prop="schoolName">
                  <Input
                    v-model="query3.schoolName"
                    clearable
                    placeholder="请输入学校名称"
                  />
                </form-item>
              </i-col>
                <i-col span="12">
                  <form-item label="学校地丘号" prop="schoolLandNum">
                    <Input
                      v-model="query3.schoolLandNum"
                      clearable
                      placeholder="请输入,格式如:1,2,3"
                    />
                  </form-item>
                </i-col>
                <i-col span="12">
                  <form-item label="学校地址" prop="schoolAddress">
                    <Input
                      v-model="query3.schoolAddress"
                      clearable
                      placeholder="请输入学校地址"
                    />
                  </form-item>
                </i-col>
                <i-col span="12">
                  <form-item label="学校介绍" prop="schoolInfo">
                    <Input type="textarea"
                      v-model="query3.schoolInfo"
                      clearable
                      placeholder="请输入学校介绍"
                    />
                  </form-item>
                </i-col>
             </row>
          </i-form>
          <div slot="footer">
              <Button type="error" size="large" long  @click="surerevise">确认</Button>
          </div>
      </Modal>

    </div>
  </div>
</template>



<script>
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import api from "../../../api/index";
const {
  selectAllCommitStudent,//学生列表信息
  selectSignUpCommitInfo,
  selectSchoolInfo,
  insertNewStudentSchool,
  getadminVerifyList,
  deleteAllInfoByStudentId,//伪删除
  educationPermissionCheck,//查询是否教育局
  selectSchoolNameAndId,
  assignSchool,
  selectDeptList,
  selectAllEducationInfo,
  exportExcelByMap
} = api;

export default {
  name: "schoollist",
  components: {
    pageHead
  },

  data() {
    return {
      btnList: [
        {name: "查询",type: "search"},
        {name: "重置",type: "refresh"},
        {name: "新增",type: "add"},
      ],
      iseducation:false,
      modal1:false,
      tapidnex:3,
      checkMsg: "",
      checkedId: "",
      showCheckMsg: false,
      modalTitle: "",
      schoolIspubliclist:[
        {index: 1,type: "公办"},
        {index: 2,type: "民办"},
      ],
      schoolTypelist:[
        {index: 0,type: "小学"},
        {index: 1,type: "初中"},
      ],
      schoolRegionlist:[
        {index: 0,type: "市直"},
        {index: 1,type: "油田"},
        {index: 2,type: "开发区"},
        {index: 3,type: "华龙区"},
        {index: 4,type: "示范区"},
      ],
      deptNamelist:[],
      deptNamelist1:[],
      query2: {
       	"schoolName": "",
       	"schoolType": "",
        'schoolRegion':'',
        "schoolIspublic":""
      },
      query3: {
        "id":'',
       	"schoolName": "",
       	"schoolType": "",
       	"schoolAddress": "",
       	"schoolLandNum": "",
       	"schoolInfo": "",
        "deptId":'',
        'schoolRegion':'',
        "schoolIspublic":""
      },
      query4: {
        "id":'',
       	"schoolName": "",
       	"schoolType": "教育局",
       	"schoolAddress": "",
       	"schoolLandNum": "",
       	"schoolInfo": "",
        "deptId":'',
        'schoolRegion':''
      },

      shoolquery:{
        schoolId:''
      },
      estateUnitNO: "",
      estateUnitNOList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum2: 1,
      pageSize2: 10,
      total2: 0,
      title: "新生入学",
      tableHeader2: [
        // {type: "selection",width:70,align: "center",},
        {title: "学校序号",key: "id",width:110,},
        {title: "学校名称",key: "schoolName",width:220},
        {title: "学校机构",key: "schoolIspublic",width:110},
        {title: "学校类型",key: "schoolType",width:110},
        {title: "行政区域",key: "schoolRegion",width:110},
        {title: "学校地丘号",key: "schoolLandNum",width:320},
        {title: "关联部门",key: "deptName",},
        {title: "学校地址",key: "schoolAddress",},
        {title: "描述",key: "schoolInfo",},
        {title: "操作",slot: "action2",width:100,},
      ],
      tableHeader3: [
        {title: "教育局序号",key: "id",width:90,},
        {title: "教育局名称",key: "schoolName",width:220},
        {title: "行政区域",key: "schoolRegion",},
        {title: "教育局地丘号",key: "schoolLandNum",},
        {title: "关联部门",key: "deptName",},
        {title: "教育局地址",key: "schoolAddress",},
        {title: "描述",key: "schoolInfo",},
        {title: "操作",slot: "action3",minWidth:46,},
      ],
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      selectedList: [],
      selectedListid:[],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    handleBtn(type){
      if (type == "add") {
       this.query3={
        "id":'',
        "schoolName": "",
        "schoolType": "",
        "schoolAddress": "",
        "schoolLandNum": "",
        "schoolInfo": "",
        "deptId":'',
        'schoolRegion':'',
        "schoolIspublic":""
       }
       this.modal1=true;
      }else  if (type == "search") {
        this.pageNum2 = 1;
        this.getLandTransferList2();
      }else  if (type == "refresh") {
        this.pageNum2 = 1;
        this.query2={
         "schoolName": "",
         "schoolType": "",
         'schoolRegion':''
        }
        this.getLandTransferList2();
      }
    },
    handleschoolDetail(row){
      console.log(row)
      let deptId=''
      if(row.deptName){
        for(let i=0;i<this.deptNamelist.length;i++){
          if(this.deptNamelist[i].dept_name==row.deptName){
            deptId=this.deptNamelist[i].id
            break;
          }
        }
      }
      this.query3={
        "id":row.id,
        "schoolName":row.schoolName,
        "schoolType": row.schoolType,
        "schoolAddress":row.schoolAddress,
        "schoolLandNum":row.schoolLandNum,
        "schoolInfo": row.schoolInfo,
        "deptId":deptId,
        'schoolRegion':row.schoolRegion,
        "schoolIspublic":row.schoolIspublic
      }
      this.modal1=true;
    },

    async surerevise () {
        if(this.query3.schoolRegion!==0){
          if(!this.query3.schoolRegion){
            this.$Message.success("请选择学校行政区域");
            return ;
          }
        }
        if(!this.query3.deptId){
          this.$Message.success("请选择学校关联部门");
          return ;
        }
       if(!this.query3.schoolName){
         this.$Message.success("请输入学校名称");
         return ;
       }
       if(!this.query3.schoolType){
         this.$Message.success("学校类型");
         return ;
       }
       if(!this.query3.schoolLandNum){
         this.$Message.success("请输入学校地丘号");
         return ;
       }
       if(!this.query3.schoolIspublic){
         this.$Message.success("请输入学校机构");
         return ;
       }
       // if(!this.query3.schoolAddress){
       //   this.$Message.success("请输入学校地址");
       //   return ;
       // }
       // if(!this.query3.schoolInfo){
       //   this.$Message.success("请输入学校描述");
       //   return ;
       // }
       if(this.query3.schoolType){
         this.query3.schoolType=this.query3.schoolType.replace(/，/g,",")
       }
       if(this.query3.schoolLandNum){
         this.query3.schoolLandNum=this.query3.schoolLandNum.replace(/，/g,",")
       }
       let newdata={}
       newdata=Object.assign(newdata,this.query3)
       if(newdata.schoolIspublic=="民办"){
         newdata.schoolIspublic=2
       }else{
         newdata.schoolIspublic=1
       }
       let res = await this.$post(insertNewStudentSchool, {
         ...newdata,
       });
       if (res.isSucceed) {
         this.$Message.success("保存成功");
         this.getLandTransferList2();
         this.modal1=false;
       }
    },

    cancelModal() {},
    pageChange2(val) {
      this.pageNum2 = val;
      this.getLandTransferList2();
    },

    async geteducationPermissionCheck(){
      if(localStorage["uid"]){
        let url=educationPermissionCheck+localStorage["uid"]
        let res = await this.$post(url, {});
        console.log(res)
        if (res.isSucceed&&res.code==1) {
          this.iseducation=true
        }else{
          this.iseducation=false
        }
      }else{
        this.$Message.info("uid过期，请重新登录");
      }
    },
    async getLandTransferList2() {
      this.isLoading = true;
      let data={
        pageNum:this.pageNum2,
        pageSize:this.pageSize2,
        ...this.query2
      }
      try {
		    let url=selectSchoolInfo+"/"+localStorage["uid"]
        let res = await this.$post(url,data);
        if(res.rows&&res.rows.length>0){
          let list = res.rows[0].list.map((item) => ({
            ...item,
            schoolIspublic:item.schoolIspublic==2?'民办':'公办'
          }));
          console.log(list);
          this.tableData2 = list;
          this.total2 = res.rows[0].total;
        }

      } finally {
        this.isLoading = false;
      }
    },

    async getselectDeptList(type) {
      this.isLoading = true;
      let url=selectDeptList+type
      let res = await this.$post(url);
      if(res.rows&&res.rows.length>0){
        for(let i=0;i<res.rows.length;i++){
          res.rows[i].index=i
        }
        console.log(res.rows)
        if(type==1){//学校关联部门
          this.deptNamelist = res.rows;
        }else if(type==2){//教育局关联部门
          this.deptNamelist1 = res.rows;
        }

      }
    },

  },

  created() {
    this.modal1=false;
    this.getLandTransferList2()
    this.getselectDeptList(1)
    this.geteducationPermissionCheck()
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin:0 20px 20px 20px;
}
.toptab{width: 100%;display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;}
.toptableft{width: 100%;display: flex;display: -webkit-flex;}
.toptableft span{width: 86px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
.bottombtn{width:150px;text-align: center;height:32px;line-height:32px;font-size: 16px;color: #FFFFFF;border-radius: 6px;background: #0097FF;}
.activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
.nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.search {width: 100%;background-color: white;border-radius: 5px;padding: 20px;margin-bottom: 20px;}

.label {width: 100px;}
.time {width: 100%;}
.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  min-height: calc(100vh - 320px);
  .page {width: 100%;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}

.statistics {padding: 10px 0;text-align: right;}

.estateTitle {color: #ff7b44;font-weight: bold;}

.estateNO {color: #ff7b44;font-weight: 400;background: #ffefe9;margin: 0 15px 10px 0;}
.topformbox{width: 100%;background: #F8F8F8;height: 80px;border-radius: 4px 4px 0px 0px;display: flex;display: -webkit-flex;align-items: center;justify-content: space-between;}
.topformbox .ivu-form{width: 100%;height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformbox .ivu-form .ivu-form-item{margin: 0;width: 360px;}
.topformbox .ivu-form .ivu-form-item:nth-child(1){margin-left: 21px;}
.topformboxright{height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformboxright span:nth-child(1){width: 92px;height: 28px;background: #FF7943;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFFFF;margin-right: 20px;}
.topformboxright span:nth-child(2){width:120px;height: 28px;background: #F9FAFA;border: 1px solid #DEDEDE;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #4B4B4B;margin-right: 20px;}

.schoolbox{width: 100%;}


</style>
